import React from 'react';

import { RecordStatusHistoryItem } from '../../types/bpaFindings.types';
import RecordStatusHistory from '../RecordStatusHistory';

interface BPAFindingStatusHistoryTabProps {
  error: string;
  isLoading: boolean;
  items: RecordStatusHistoryItem[];
}

const BPAFindingStatusHistoryTab: React.FC<BPAFindingStatusHistoryTabProps> = ({
  error,
  isLoading,
  items,
}) => {
  return (
    <RecordStatusHistory
      items={error ? [] : items}
      isLoading={isLoading}
      emptyMessage={
        error ? 'Unable to load history, please try later.' : undefined
      }
    />
  );
};

export default BPAFindingStatusHistoryTab;
